import { useQuery } from 'react-query'

import { REPORT_ENTITY_STALE_TIME_MS } from '@webapp/modules/reports/constants'
import { isNotFoundError } from '@webapp/modules/reports/utils/isNotFoundError'
import { vendorQueryConfig } from '@webapp/modules/vendor'

// Reuses the vendor module's query config through its public API (ADR-6).
// The header only needs the vendor's name, so it reads it from the
// Constructor payload rather than building the vendor-management entity
// (ADR-7). `enabled` lets the config-driven detail FS call all three header
// hooks unconditionally (rules-of-hooks) while fetching only its own
// config's entity.
export const useQueryReportVendor = (
  vendorId: number,
  enabled = true,
  { onError }: { onError?: (error: unknown) => void } = {}
) => {
  const { data, isFetching, error } = useQuery({
    ...vendorQueryConfig.getVendor(vendorId),
    staleTime: REPORT_ENTITY_STALE_TIME_MS,
    enabled,
    // A 404 is reported through `isNotFound`; only other failures reach
    // the caller's handler.
    onError:
      onError &&
      ((queryError: unknown) => {
        if (!isNotFoundError(queryError)) {
          onError(queryError)
        }
      }),
  })

  return {
    vendorName: data?.data.name ?? null,
    isLoading: isFetching,
    isNotFound: isNotFoundError(error),
  }
}
